export function faqSearchScroll() {
    let winLocation = window.location.toString();
    if (winLocation.indexOf("?search-by-keywords") >= 0 || winLocation.indexOf("property_types") >=0) {
        $("html, body").animate({
            scrollTop: $(".faqs-box .faqs-wrapper").offset().top - $(".header").innerHeight()
        }, 500);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/faqSearchScroll.js